import { render, staticRenderFns } from "./GJgrowActivity.vue?vue&type=template&id=7c48bcc6&scoped=true&"
import script from "./GJgrowActivity.vue?vue&type=script&lang=ts&"
export * from "./GJgrowActivity.vue?vue&type=script&lang=ts&"
import style0 from "./GJgrowActivity.vue?vue&type=style&index=0&id=7c48bcc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c48bcc6",
  null
  
)

export default component.exports